module.exports = __webpack_public_path__ + "static/media/CV_Sabesan_Sathananthan.979cc253.pdf";